import React, { useState, useEffect } from "react";
import { XCircle, PencilSquare, ToggleOn, ToggleOff } from "react-bootstrap-icons";
import Axios from "../config/AxiosConfig";
import EditUserModal from "./models/EditUserModal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const User = () => {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    fetchUsers();
  }, [page, searchQuery]);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const response = await Axios.get(`super-admin/users`, {
        params: { username: searchQuery, page, limit: 10 },
      });
      setUsers(response.data.users);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching users:", error);
      setUsers([]);
    }
    setLoading(false);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setSearchQuery("");
  };

  const toggleUserStatus = async (userId, currentStatus) => {
    try {
      const newStatus = !currentStatus;
      await Axios.put(`/super-admin/user-status/${userId}`, { isEnabled: newStatus });
      toast.success(`User ${newStatus ? "enabled" : "disabled"} successfully`);
      fetchUsers();
    } catch (error) {
      toast.error("Failed to update user status");
      console.error("Error toggling user status:", error);
    }
  };

  return (
    <div className="user-container">
      <h2>Users List</h2>

      <div className="search-container">
        <div className="search-input-wrapper">
          <input
            type="text"
            placeholder="Search by User Name"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {searchTerm && <XCircle className="clear-icon" size={18} onClick={handleClearSearch} />}
        </div>
        <button onClick={() => setSearchQuery(searchTerm)}>Search</button>
      </div>

      <table className="user-table">
        <thead>
          <tr>
            <th>SNo</th>
            <th>User Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Created At</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr><td colSpan="7">Loading...</td></tr>
          ) : users.length > 0 ? (
            users.map((user, index) => (
              <tr key={user._id}>
                <td>{index + 1 + (page - 1) * 10}</td>
                <td>{user.username}</td>
                <td>{user.email}</td>
                <td>{user.phoneNumber || "N/A"}</td>
                <td>{new Date(user.createdAt).toLocaleDateString()}</td>
                <td>
                  {user.isEnabled ? (
                    <ToggleOn className="status-enabled" size={26} onClick={() => toggleUserStatus(user._id, user.isEnabled)} />
                  ) : (
                    <ToggleOff className="status-disabled" size={26} onClick={() => toggleUserStatus(user._id, user.isEnabled)} />
                  )}
                </td>
                <td>
                  <PencilSquare className="edit-icon" size={18} onClick={() => setSelectedUser(user)} />
                </td>
              </tr>
            ))
          ) : (
            <tr><td colSpan="7">No users found</td></tr>
          )}
        </tbody>
      </table>
      
      {users.length > 0 && (
        <div className="pagination">
          <button disabled={page === 1} onClick={() => setPage(page - 1)}>Previous</button>
          {[...Array(totalPages)].map((_, i) => (
            <button key={i} className={page === i + 1 ? "active" : ""} onClick={() => setPage(i + 1)}>
              {i + 1}
            </button>
          ))}
          <button disabled={page === totalPages} onClick={() => setPage(page + 1)}>Next</button>
        </div>
      )}

      {selectedUser && <EditUserModal isOpen={Boolean(selectedUser)} onClose={() => setSelectedUser(null)} userData={selectedUser} refreshData={fetchUsers} />}
    </div>
  );
};

export default User;
